/**
 * Class Filter
 */
class Filter {
    /**
     * @param {string} filter - The filter container
     */
    constructor(filter) {
        this.filter = $(filter);
        this.fields = this.filter.find('[type="checkbox"], select');
        this.mobile_bar = $('.js-catalog-mobile-bar');

        this.clear = $('[data-trigger="clear-filter"]');
        this.collapse = $('[data-trigger="collapse-filter"]');

        this.init();
    }

    /**
     * Clear Event Handler
     *
     * @returns {void}
     */
    clearEventHandler() {
        this.clear.on('click', () => {
            let type, field, tagName;

            this.fields.each((index, element) => {
                field = $(element);
                tagName = field.prop('tagName').toLowerCase();
                type = field.prop('type').toLowerCase();

                if (tagName === 'select') {
                    field.find('option[value=""]').prop('selected', true);
                }

                if (tagName === 'input' && type === 'checkbox') {
                    field.prop('checked', false);
                }
            })
        });
    }

    /**
     * Collapse Event Handler
     *
     * @returns {void}
     */
    collapseEventHandler() {
        this.collapse.on('click', (event) => {
            const current = $(event.target);
            const openText = current.data('open');
            const closeText = current.data('close');

            if (current.hasClass('is-active')) {
                current.removeClass('is-active').text(openText);
                this.filter.removeClass('is-active');
                this.mobile_bar.removeClass('active');
            } else {
                current.addClass('is-active').text(closeText);
                this.filter.addClass('is-active');
                this.mobile_bar.addClass('active');
            }
        });

        if ($('body').hasClass('version-2') && $(window).width() < 768) {
            this.filter.removeClass('is-active');
            this.collapse.filter('.is-active').removeClass('is-active');
        }
    }

    /**
     * Init method
     *
     * @returns {void}
     */
    init() {
        this.clearEventHandler();
        this.collapseEventHandler();
    }
}

export default Filter;
